export const CSV_KEYS = [
  'location',
  'Layout Name',
  'Layout Name Timestamp',
  'Ready for Allocation',
  'Ready for Allocation Update Reason',
  'Ready for Allocation Timestamp',
  'Public Status',
  'Public Status Timestamp',
  'Holiday Screen Start Date',
  'Holiday Screen End Date',
  'Pretty Name',
  'Pretty Name Timestamp',
  'Price Map Template',
  'Price Map Template Timestamp',
  'Fridge Schema Template',
  'Fridge Schema Template Timestamp',
  'Mobile Ordering',
  'Mobile Ordering Timestamp',
];

export const ALLOWED_ATTRIBUTES = {
  'Layout Name': 'layoutName',
  'Ready for Allocation': 'prod',
  'Ready for Allocation Update Reason': 'updateReason',
  'Public Status': 'publicStatus',
  'Holiday Screen Enabled': 'holidayScreenEnabled',
  'Holiday Screen Start Date': 'holidayScreenStartDate',
  'Holiday Screen End Date': 'holidayScreenEndDate',
  'Pretty Name': 'prettyName',
  'Price Map Template': 'priceMapTemplate',
  'Fridge Schema Template': 'fridgeSchema',
  // Secret undocumented field, only for tech use!
  'Mobile Ordering': 'reserve',
};

export const ALLOWED_ATTRIBUTE_VALUES = {
  'Ready for Allocation': ['', 0, 1],
  'Public Status': ['', 'LIVE', 'OFFLINE'],
  'Holiday Screen Enabled': ['', true, false],
  'Layout Name': [''],
  'Price Map Template': [''],
  'Fridge Schema Template': [''],
  // Secret undocumented field, only for tech use!
  'Mobile Ordering': ['', 0, 1],
};

// csv keys that are used for scheduling holidays
export const HOLIDAY_KEYS = [
  'Holiday Screen Start Date',
  'Holiday Screen End Date',
];

// csv keys that are only indicate schedule timestamps and not Location table attributes
export const TS_KEYS = [
  'Layout Name Timestamp',
  'Ready for Allocation Timestamp',
  'Public Status Timestamp',
  'Pretty Name Timestamp',
  'Price Map Template Timestamp',
  'Fridge Schema Template Timestamp',
  'Mobile Ordering Timestamp',
];

// csv keys that indicate valid Location table attributes
export const ATTR_WITH_TS = [
  'Layout Name',
  'Ready for Allocation',
  'Public Status',
  'Pretty Name',
  'Price Map Template',
  'Fridge Schema Template',
  'Mobile Ordering',
];

// holiday start and end dates should be of the format YYYY-mm-dd
// timestamp is assigned automatically on the backend
export const HOLIDAY_DATE_FORMAT = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/;

// The csv timestamp should be of format YYYY-mm-dd HH:MM:SS, in CST
// milliseconds will default to 0
export const SCHEDULE_TIMESTAMP_FORMAT =
  /^[0-9]{4}-[0-9]{2}-[0-9]{2}\s[0-9]{2}:[0-9]{2}:[0-9]{2}$/;

// Possible reasons for changing Ready for Allocation value
export const ALLOCATION_UPDATE_REASONS = [
  'End of Holiday Break',
  'First Stocking',
  'Fridge being removed',
  'Fridge not getting removed',
  'Holiday Break',
  'Other',
];
